import { ReactElement } from "react";
import styles from "rivals/components/shared/Icons/Icons.module.scss";
import type { IconProps } from "./iconPropsTypes";

const RemoveIcon = ({
  fill,
  height = "12",
  width = "12"
}: IconProps): ReactElement => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 12 12"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.25 5.625L9.75 5.625V6.375L2.25 6.375V5.625Z"
      fill={fill || styles.white}
    />
    <title>remove</title>
  </svg>
);

export default RemoveIcon;
